import { render, staticRenderFns } from "./user_app_shortcuts.vue?vue&type=template&id=b03a5d78&scoped=true&"
import script from "./user_app_shortcuts.vue?vue&type=script&lang=js&"
export * from "./user_app_shortcuts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03a5d78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b03a5d78')) {
      api.createRecord('b03a5d78', component.options)
    } else {
      api.reload('b03a5d78', component.options)
    }
    module.hot.accept("./user_app_shortcuts.vue?vue&type=template&id=b03a5d78&scoped=true&", function () {
      api.rerender('b03a5d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/user/header_block/user_app_shortcuts.vue"
export default component.exports